// Module
var code = "<h2 id=\"trouble-paying\">Trouble Paying</h2> <p>If you can&#39;t afford your student loan payments, don&#39;t wait until you fall behind to seek assistance. We offer options that can help.</p> ";
// Exports
export default code;